























































































import { Component, Ref, Vue, Prop } from "vue-property-decorator";
import { Auth } from "aws-amplify";
import * as rules from '@/rules';
import { Urls } from '@/Urls';

@Component({
    components: {}
})
export default class ResetPassword extends Vue {
    private readonly Urls = Urls;

    @Prop({ default:false, type: Boolean})
    isPopup!: boolean;

    @Ref()
    formRef: HTMLFormElement;

    private rules = {
        required: rules.REQUIRED,
        emailFormat: rules.EMAIL_FORMAT
    }

    private username: string = '';
    private resetSent = false;

    private resetPassword() {
        if (!this.formRef.validate()) {
            return;
        }

        Auth.forgotPassword(this.username)
            .then(() => {
                this.resetSent = true;
            })
            .catch((err) => {
                console.log(err);
            })

    }
}
